(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var run = function () {
    var h = document.querySelector('[id*="__hero"] .h1, [id*="__hero"] .koda-barnwall__title');
    if (!h || h.dataset.kodaSplit) return;
    h.dataset.kodaSplit = "1";
    var words = h.textContent.trim().split(/\s+/);
    h.innerHTML = words.map(function (w, i) {
      return '<span style="display:inline-block;opacity:0;transform:translateY(16px);transition:opacity .55s ease ' + (0.2 + i * 0.14) + 's, transform .55s ease ' + (0.2 + i * 0.14) + 's">' + w + '</span>';
    }).join(' ');
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      Array.prototype.forEach.call(h.querySelectorAll('span'), function (s) {
        s.style.opacity = 1; s.style.transform = 'none';
      });
    }); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Header compaction with hysteresis (8/26). Compact once the page is clearly scrolled; expand only when nearly back at the top.
   The dead zone (60–180px) is wider than the header's height change, so shrinking the header can never re-trigger itself. */
(function () {
  var ON = 180, OFF = 60, compact = false, ticking = false;
  var apply = function () {
    ticking = false;
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    if (!compact && y > ON) { compact = true; document.documentElement.setAttribute('data-koda-compact', ''); }
    else if (compact && y < OFF) { compact = false; document.documentElement.removeAttribute('data-koda-compact'); }
  };
  var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(apply); } };
  window.addEventListener('scroll', onScroll, { passive: true });
  apply();
})();
